{
    "DAYS": "jours",
    "HOURS": "heures",
    "MINUTES": "minutes",
    "SECONDS": "secondes",
    "STARTING_SOON": "Commence bientôt...",
    "EVENT_NOT_STARTED": "Cet événement n'a pas commencé...",
    "DEFAULT_ERROR": "Erreur de lecture",
    "DEFAULT_ERROR_DESCRIPTION": "Impossible de lire la vidéo. Veuillez réessayer plus tard.",
    "API_ERROR": "Échec de la récupération des informations vidéo",
    "API_ERROR_DESCRIPTION": "Erreur lors de la récupération des détails de la vidéo. Vérifiez votre videoId et votre connexion Internet, puis réessayez.",
    "ERROR_CODE_NOT_AUTHENTICATED": "Autorisation",
    "ERROR_CODE_NOT_AUTHENTICATED_DESCRIPTION": "Vous n'avez pas la permission de lire cette vidéo.",
    "ERROR_CODE_GEO_BLOCKED": "Restriction de géoblocage",
    "ERROR_CODE_GEO_BLOCKED_DESCRIPTION": "Désolé, cette vidéo n'est pas disponible dans votre région en raison de restrictions de géoblocage.",
    "ERROR_CODE_NOT_ENTITLED": "Non autorisé",
    "ERROR_CODE_NOT_ENTITLED_DESCRIPTION": "Désolé, vous n'êtes pas autorisé à lire cette vidéo.",
    "ERROR_CODE_VPN_BLOCKED": "VPN BLOQUÉ",
    "ERROR_CODE_VPN_BLOCKED_DESCRIPTION": "Cette vidéo n'est pas disponible en raison de l'utilisation d'un VPN.",
    "ERROR_CODE_IP_CHANGED": "Changement de réseau",
    "ERROR_CODE_IP_CHANGED_DESCRIPTION": "Vous avez changé de réseau de manière inattendue. Veuillez réessayer.",
    "ERROR_CODE_VPN_DETECTED": "VPN détecté",
    "ERROR_CODE_VPN_DETECTED_DESCRIPTION": "Nous avons détecté un VPN. Veuillez le désactiver et réessayer.",
    "ERROR_CODE_ANONYMOUS_PROXY": "Proxy anonyme détecté",
    "ERROR_CODE_ANONYMOUS_PROXY_DESCRIPTION": "Nous avons détecté un proxy anonyme ou un serveur. Veuillez le désactiver et réessayer."
}
